var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wrap', _vm.osClass]},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.htmlSrc,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }